import React from 'react';
import { BlogCategory, blogCategories, categoryColors } from '@/data/blogPosts';

interface BlogCategoryFilterProps {
  selectedCategory: BlogCategory | null;
  onCategoryChange: (category: BlogCategory | null) => void;
  postCounts?: Record<BlogCategory | 'all', number>;
}

const BlogCategoryFilter: React.FC<BlogCategoryFilterProps> = ({
  selectedCategory,
  onCategoryChange,
  postCounts
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {/* All button */}
      <button
        onClick={() => onCategoryChange(null)}
        className={`
          inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium
          transition-all duration-300 border
          ${selectedCategory === null
            ? 'bg-primary text-primary-foreground border-primary shadow-md'
            : 'bg-sidebar text-muted-foreground border-border hover:border-primary/50 hover:text-foreground'
          }
        `}
      >
        All
        {postCounts && (
          <span className={`
            text-xs px-1.5 py-0.5 rounded-full
            ${selectedCategory === null
              ? 'bg-primary-foreground/20 text-primary-foreground'
              : 'bg-background text-muted-foreground'
            }
          `}>
            {postCounts.all}
          </span>
        )}
      </button>

      {/* Category buttons */}
      {blogCategories.map((category) => {
        const colors = categoryColors[category];
        const isSelected = selectedCategory === category;

        return (
          <button
            key={category}
            onClick={() => onCategoryChange(category)}
            className={`
              inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium
              transition-all duration-300 border
              ${isSelected
                ? `${colors.bg} ${colors.text} ${colors.border} shadow-md`
                : 'bg-sidebar text-muted-foreground border-border hover:border-primary/50 hover:text-foreground'
              }
            `}
          >
            {category}
            {postCounts && postCounts[category] !== undefined && (
              <span className={`
                text-xs px-1.5 py-0.5 rounded-full
                ${isSelected
                  ? 'bg-current/10'
                  : 'bg-background text-muted-foreground'
                }
              `}>
                {postCounts[category]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default BlogCategoryFilter;
